"use client"

// import { TrendingUp, TrendingDown, DollarSign, Users, Activity } from "lucide-react"
// import { useGetAllCampaigns } from "@/lib/api/hooks"
// import { ChartAreaInteractive } from "@/components/chart-area-interactive"
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"

export default function HomePage() {

  // // Fetch campaigns
  // const { data: campaignsData, isPending: isLoadingCampaigns } = useGetAllCampaigns()
  // const campaigns = campaignsData?.data || []

  // // Filter campaigns for Recent Campaigns section
  // const filteredCampaigns = campaigns

  // // Metrics matching shadcn dashboard-01 style
  // const metrics = [
  //   {
  //     title: "Total Revenue",
  //     value: "$1,250.00",
  //     description: "+12.5%",
  //     trend: {
  //       label: "Trending up this month",
  //       value: "+12.5%",
  //       isPositive: true,
  //     },
  //     icon: DollarSign,
  //   },
  //   {
  //     title: "New Customers",
  //     value: "1,234",
  //     description: "-20%",
  //     trend: {
  //       label: "Down 20% this period",
  //       value: "-20%",
  //       isPositive: false,
  //       note: "Acquisition needs attention",
  //     },
  //     icon: Users,
  //   },
  //   {
  //     title: "Active Accounts",
  //     value: "45,678",
  //     description: "+12.5%",
  //     trend: {
  //       label: "Strong user retention",
  //       value: "+12.5%",
  //       isPositive: true,
  //       note: "Engagement exceed targets",
  //     },
  //     icon: Activity,
  //   },
  //   {
  //     title: "Growth Rate",
  //     value: "4.5%",
  //     description: "+4.5%",
  //     trend: {
  //       label: "Steady performance increase",
  //       value: "+4.5%",
  //       isPositive: true,
  //       note: "Meets growth projections",
  //     },
  //     icon: TrendingUp,
  //   },
  // ]

  return (
    <div className="flex-1 flex items-center justify-center p-4 md:p-8 bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold tracking-tight">Welcome to Engage AI</h1>
        <p className="text-lg text-muted-foreground">
          Use the menu to navigate to different sections of the application.
        </p>
      </div>
    </div>
  )

  // return (
  //   <div className="flex-1 space-y-4 p-4 md:p-8 pt-6 bg-background">


  //     {/* Metric Cards - Matching shadcn dashboard-01 style */}
  //     <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
  //       {metrics.map((metric) => {
  //         const Icon = metric.icon
  //         const TrendIcon = metric.trend.isPositive ? TrendingUp : TrendingDown

  //         return (
  //           <Card key={metric.title}>
  //             <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
  //               <CardTitle className="text-sm font-medium">
  //                 {metric.title}
  //               </CardTitle>
  //               <Icon className="h-4 w-4 text-muted-foreground" />
  //             </CardHeader>
  //             <CardContent>
  //               <div className="text-2xl font-bold">{metric.value}</div>
  //               <p className="text-xs text-muted-foreground mt-1">
  //                 {metric.description}
  //               </p>
  //               <div className="flex items-center pt-1">
  //                 <TrendIcon
  //                   className={`h-3 w-3 mr-1 ${
  //                     metric.trend.isPositive
  //                       ? "text-green-600 dark:text-green-400"
  //                       : "text-red-600 dark:text-red-400"
  //                   }`}
  //                 />
  //                 <span
  //                   className={`text-xs ${
  //                     metric.trend.isPositive
  //                       ? "text-green-600 dark:text-green-400"
  //                       : "text-red-600 dark:text-red-400"
  //                   }`}
  //                 >
  //                   {metric.trend.value}
  //                 </span>
  //                 <span className="text-xs text-muted-foreground ml-1">
  //                   {metric.trend.label}
  //                 </span>
  //               </div>
  //               {metric.trend.note && (
  //                 <p className="text-xs text-muted-foreground mt-1">
  //                   {metric.trend.note}
  //                 </p>
  //               )}
  //             </CardContent>
  //           </Card>
  //         )
  //       })}
  //     </div>

  //     {/* Chart Section - Matching shadcn dashboard-01 */}
  //     <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7">
  //       <Card className="col-span-4">
  //         <CardHeader>
  //           <CardTitle>Total Visitors</CardTitle>
  //           <CardDescription>
  //             Total for the last 3 months
  //           </CardDescription>
  //         </CardHeader>
  //         <CardContent>
  //           <ChartAreaInteractive />
  //         </CardContent>
  //       </Card>
  //       <Card className="col-span-3">
  //         <CardHeader>
  //           <CardTitle>Recent Campaigns</CardTitle>
  //           <CardDescription>
  //             Latest campaign activity
  //           </CardDescription>
  //         </CardHeader>
  //         <CardContent>
  //           {isLoadingCampaigns ? (
  //             <div className="text-sm text-muted-foreground">Loading campaigns...</div>
  //           ) : filteredCampaigns.length === 0 ? (
  //             <div className="text-sm text-muted-foreground">
  //               No campaigns yet.
  //             </div>
  //           ) : (
  //             <div className="space-y-4">
  //               {filteredCampaigns.slice(0, 5).map((campaign) => (
  //                 <div key={campaign.id} className="flex items-center justify-between">
  //                   <div className="space-y-1">
  //                     <p className="text-sm font-medium leading-none">
  //                       {campaign.name || "Unnamed Campaign"}
  //                     </p>
  //                     <p className="text-xs text-muted-foreground">
  //                       {campaign.agentType || "N/A"}
  //                     </p>
  //                   </div>
  //                 </div>
  //               ))}
  //               {filteredCampaigns.length > 5 && (
  //                 <p className="text-xs text-muted-foreground text-center">
  //                   +{filteredCampaigns.length - 5} more campaigns
  //                 </p>
  //               )}
  //             </div>
  //           )}
  //         </CardContent>
  //       </Card>
  //     </div>

  //   </div>
  // )
}
